<section class="custom-route__more">
  <form 
    [formGroup]="form"
    class="more__form"
  >
    <h2 class="ci-paragraph-p2-semibold">
      {{ 'Información para el turista'  | translate }}
    </h2>
    
    <app-email-field
      [form]="form"
      formControlName="email"
    />
    
    <app-name-field
      [form]="form"
      formControlName="name"
    />
    
    <app-extra-info-field
      [form]="form"
      formControlName="extraInfo"
    />
    
    <app-terms-check-field
      [form]="form"
      formControlName="terms"
    />
     
    <div class="more__submit-buttons">
      @if (isDesktopView) {
        <ci-button
          class="more__submit-button"
          class-name="ci-btn-primary-s-outlined"
          type="button"
          [attr.aria-label]="'Volver' | translate"
          (click)="handleCancel()"
        >
          {{ 'Volver' | translate }}
        </ci-button>
      }
      <ci-button
        class="more__submit-button"
        class-name="ci-btn-primary-s-filled"
        type="submit"
        [disabled]="!form.valid"
        [attr.aria-label]="'Enviar mi ruta' | translate"
        (click)="handleSubmit()"
      >
        {{ 'Enviar mi ruta' | translate }}
      </ci-button>
    </div>
  </form>
</section>
